import React from 'react'
import { Route, Switch } from 'wouter'

import ImportShippingInvoices from './import_shipping_invoices'
import ImportCommissionsCollectionsInvoices from './import_commissions_collections_invoices'
import ImportInvoiceEurotax from './import_invoice_eurotax'
import ImportCostWarehouse from './import_cost_warehouse'
import ImportCommissionsCollectionsV2 from './import_commissions_collections_v2'

export function InvoicesGroup() {
  return (
    <div>
      <Switch>
        <Route path="/invoices/import-shipping-invoices">
          <ImportShippingInvoices />
        </Route>
        <Route path="/invoices/import-commissions-collections">
          <ImportCommissionsCollectionsInvoices />
        </Route>
        <Route path="/invoices/import-invoice-eurotax">
          <ImportInvoiceEurotax />
        </Route>
        <Route path="/invoices/import-cost-warehouse">
          <ImportCostWarehouse />
        </Route>
        <Route path="/invoices/import-commissions-collections-v2">
          <ImportCommissionsCollectionsV2 />
        </Route>
      </Switch>
    </div>
  )
}
